const fs = require('fs');
const dotenv = require('dotenv');

const ENV_PATH = '.env';
const ENV_PREFIX = 'VUE_APP_';

/**
 * @returns {Object}
 */
const getRawEnv = () => dotenv.parse(fs.readFileSync(ENV_PATH));

/**
 * Set process.env
 * @returns {void}
 */
const envInit = () => Object.entries(getRawEnv()).forEach(([key, value]) => {
  process.env[`${ENV_PREFIX}${key}`] = value;
});

/**
 * Get process.env
 * @returns {Object}
 */
const getEnv = () => Object.entries(process.env).reduce((env, [key, value]) => {
  const k = key.replace(ENV_PREFIX, '');

  return {
    ...env,
    [k]: value,
  };
}, {});

module.exports = {
  getRawEnv,
  envInit,
  getEnv,
};
